import { useCallback } from "react";
import { removeMADetailFromParentRoll, updateMADetailFromParentRoll } from "../services/productionService";

const useAddMANumberByParentRollId = (callMessage) => {
    const updateMA = useCallback(async (selectedMode, editSalaryStructureID, requestBody) => {
        try {


            const successMessage = selectedMode === 0
                ? (editSalaryStructureID !== 0
                    ? 'MA Detail Updated Successfully'
                    : 'MA Detail Updated Successfully')
                : 'Issued indent Approved Successfully';

            // Await the API response
            const data = await updateMADetailFromParentRoll(requestBody);

            if (data?.length > 0) {
                if(data[0].id===0){
                    callMessage('info', successMessage, 'info');
                }
                else{
                    callMessage('info', 'Planned quantity is less than the converted quantity, so the MA planned quantity cannot be changed.', 'info');
                }
                
            } else {
                callMessage('error', 'No data received from API', 'Error');
            }
        } catch (error) {
            callMessage('error', error.message || 'An unexpected error occurred', 'Error');
        }
    }, [callMessage]);

    return { updateMA };

}
export default useAddMANumberByParentRollId;



